/**
 * Affordable Supplies — Theme JavaScript
 * Startup animation, mobile menu, scroll animations,
 * product search/sort/filter
 */

document.addEventListener("DOMContentLoaded", () => {
  initSplashScreen();
  initHeader();
  initMobileMenu();
  initScrollAnimations();
  initProductControls();
  initCart();
});

/* ========== Splash Screen ========== */
function initSplashScreen() {
  const splash = document.querySelector(".splash");
  if (!splash) return;

  const seen = sessionStorage.getItem("splash_seen");
  if (seen) {
    splash.classList.add("is-hidden");
    document.body.style.overflow = "";
    return;
  }

  document.body.style.overflow = "hidden";

  setTimeout(() => {
    splash.classList.add("is-hidden");
    document.body.style.overflow = "";
    sessionStorage.setItem("splash_seen", "1");
  }, 2800);
}

/* ========== Header Scroll Effect ========== */
function initHeader() {
  const header = document.querySelector(".site-header");
  if (!header) return;

  const onScroll = () => {
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  };

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
}

/* ========== Mobile Menu ========== */
function initMobileMenu() {
  const toggle = document.querySelector(".menu-toggle");
  const nav = document.querySelector(".mobile-nav");
  if (!toggle || !nav) return;

  toggle.addEventListener("click", () => {
    toggle.classList.toggle("is-active");
    nav.classList.toggle("is-active");
    document.body.style.overflow = nav.classList.contains("is-active")
      ? "hidden"
      : "";
  });

  nav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      toggle.classList.remove("is-active");
      nav.classList.remove("is-active");
      document.body.style.overflow = "";
    });
  });
}

/* ========== Scroll Animations ========== */
function initScrollAnimations() {
  const elements = document.querySelectorAll(".animate-on-scroll");
  if (!elements.length) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -40px 0px" },
  );

  elements.forEach((el) => observer.observe(el));
}

/* ========== Product Search / Sort / Filter ========== */
function initProductControls() {
  const searchInput = document.querySelector("#product-search");
  const sortSelect = document.querySelector("#product-sort");
  const filterBtns = document.querySelectorAll(".shop-filter-btn");
  const grid = document.querySelector(".product-grid");
  if (!grid) return;

  let activeFilter = "all";

  /* Search */
  if (searchInput) {
    searchInput.addEventListener(
      "input",
      debounce(() => {
        filterAndSort();
      }, 250),
    );
  }

  /* Sort */
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      filterAndSort();
    });
  }

  /* Category filter buttons */
  filterBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      const href = btn.getAttribute("href");
      const isLocalPreview =
        window.location.pathname.includes("preview.html") ||
        window.location.protocol === "file:";

      if (btn.tagName === "A" && href && !isLocalPreview) {
        // Let the link navigate normally to load all products server-side
        return;
      }

      e.preventDefault();
      filterBtns.forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      activeFilter = (btn.dataset.filter || "all").toLowerCase();
      filterAndSort();
    });
  });

  function filterAndSort() {
    const cards = Array.from(grid.querySelectorAll(".product-card"));
    const query = (searchInput?.value || "").toLowerCase().trim();
    const sort = sortSelect?.value || "default";

    /* Filter */
    cards.forEach((card) => {
      const title = (card.dataset.title || "").toLowerCase();
      const category = (card.dataset.category || "").toLowerCase();
      const matchesSearch =
        !query || title.includes(query) || category.includes(query);
      const matchesFilter =
        activeFilter === "all" ||
        category === activeFilter ||
        (category && activeFilter && (category.includes(activeFilter) || activeFilter.includes(category)));
      card.style.display = matchesSearch && matchesFilter ? "" : "none";
    });

    /* Sort visible cards */
    const visible = cards.filter((c) => c.style.display !== "none");
    visible.sort((a, b) => {
      switch (sort) {
        case "az":
          return (a.dataset.title || "").localeCompare(b.dataset.title || "");
        case "za":
          return (b.dataset.title || "").localeCompare(a.dataset.title || "");
        case "price-low":
          return (
            parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0)
          );
        case "price-high":
          return (
            parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0)
          );
        default:
          return 0;
      }
    });

    visible.forEach((card) => grid.appendChild(card));

    /* Show empty state */
    let emptyMsg = grid.querySelector(".product-grid__empty");
    if (visible.length === 0) {
      if (!emptyMsg) {
        emptyMsg = document.createElement("div");
        emptyMsg.className = "product-grid__empty";
        emptyMsg.innerHTML = `
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
          </svg>
          <p>No products match your search. Try a different keyword or category.</p>
        `;
        grid.appendChild(emptyMsg);
      }
      emptyMsg.style.display = "";
    } else if (emptyMsg) {
      emptyMsg.style.display = "none";
    }
  }
}

/* ========== Utility ========== */
function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}
/* ========== AJAX Cart ========== */
function initCart() {
  const selectors = {
    drawer: "#cart-drawer",
    overlay: "#cart-drawer-overlay",
    closeBtn: "#cart-drawer-close",
    itemsContainer: "#cart-drawer-items",
    footer: "#cart-drawer-footer",
    subtotal: "#cart-subtotal",
    checkoutPrice: "#cart-checkout-price",
    cartCount: ".cart-count-bubble",
    cartIcon: ".header-cart-btn",
    addBtn: 'form[action="/cart/add"]',
  };

  const drawer = document.querySelector(selectors.drawer);
  if (!drawer) return;

  // Open drawer
  document.querySelectorAll(selectors.cartIcon).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openCart();
    });
  });

  // Close drawer
  document
    .querySelector(selectors.closeBtn)
    ?.addEventListener("click", closeCart);
  document
    .querySelector(selectors.overlay)
    ?.addEventListener("click", closeCart);

  // Close on Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer.classList.contains("is-active")) {
      closeCart();
    }
  });

  // Handle Quantity & Remove
  drawer.addEventListener("click", (e) => {
    const target = e.target.closest("button");
    if (!target) return;

    const action = target.dataset.action;
    const id = target.dataset.id;

    if (action === "increase") {
      changeQuantity(id, 1);
    } else if (action === "decrease") {
      changeQuantity(id, -1);
    } else if (action === "remove") {
      updateCartItem(id, 0);
    } else if (action === "close-drawer") {
      e.preventDefault();
      closeCart();
      window.location.href = target.getAttribute("href");
    }
  });

  // Handle Add to Cart Forms
  document.addEventListener("submit", (e) => {
    if (e.target.action && e.target.action.includes("/cart/add")) {
      e.preventDefault();
      const formData = new FormData(e.target);
      addToCart(formData);
    }
  });

  // --- Functions ---

  function openCart() {
    drawer.classList.add("is-active");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    fetchCart(); // Refresh data on open
  }

  function closeCart() {
    drawer.classList.remove("is-active");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  async function fetchCart() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  }

  async function addToCart(formData) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });
      const item = await res.json();
      openCart();
      fetchCart();
    } catch (err) {
      console.error("Error adding to cart:", err);
    }
  }

  async function updateCartItem(id, quantity) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: id, quantity: quantity }),
      });
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (err) {
      console.error("Error updating cart:", err);
    }
  }

  async function changeQuantity(id, delta) {
    const input = document.querySelector(
      `.cart-item__qty-input[data-id="${id}"]`,
    );
    if (!input) return;
    const newQty = parseInt(input.value) + delta;
    if (newQty < 0) return;
    updateCartItem(id, newQty);
  }

  function updateCartCount(count) {
    document.querySelectorAll(selectors.cartCount).forEach((el) => {
      el.textContent = count;
      el.classList.toggle("is-hidden", count === 0);
    });
  }

  function renderCart(cart) {
    const container = document.querySelector(selectors.itemsContainer);
    const footer = document.querySelector(selectors.footer);
    const subtotal = document.querySelector(selectors.subtotal);
    const checkoutPrice = document.querySelector(selectors.checkoutPrice);

    // Update prices
    if (subtotal) subtotal.innerHTML = formatMoney(cart.total_price);
    if (checkoutPrice) checkoutPrice.innerHTML = formatMoney(cart.total_price);

    // Empty state
    if (cart.item_count === 0) {
      container.innerHTML = `
        <div class="cart-drawer__empty">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="48" height="48">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
          </svg>
          <p>Your cart is currently empty.</p>
          <a href="/collections/all" class="btn btn--primary btn--sm" data-action="close-drawer">Start Shopping</a>
        </div>
      `;
      if (footer) footer.classList.add("is-hidden");
      return;
    }

    if (footer) footer.classList.remove("is-hidden");

    // Items list
    const itemsHtml = cart.items
      .map(
        (item) => `
      <div class="cart-item" data-id="${item.key}">
        <div class="cart-item__image">
          ${
            item.image
              ? `<img src="${item.image}" alt="${item.title}" width="100" height="100" loading="lazy">`
              : `<div class="placeholder-svg"></div>`
          }
        </div>
        <div class="cart-item__details">
          <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
          ${
            item.variant_title !== null &&
            !item.variant_title.includes("Default Title")
              ? `<p class="cart-item__variant">${item.variant_title}</p>`
              : ""
          }
          <div class="cart-item__price-wrapper">
             <div class="cart-item__price">
              ${
                item.original_line_price !== item.final_line_price
                  ? `<s class="cart-item__old-price">${formatMoney(item.original_line_price)}</s> `
                  : ""
              }
              <span class="cart-item__final-price">${formatMoney(item.final_line_price)}</span>
            </div>
            <div class="cart-item__qty">
              <button type="button" class="cart-item__qty-btn" data-action="decrease" data-id="${
                item.key
              }">−</button>
              <input type="number" class="cart-item__qty-input" value="${
                item.quantity
              }" min="0" data-id="${item.key}" readonly>
              <button type="button" class="cart-item__qty-btn" data-action="increase" data-id="${
                item.key
              }">+</button>
            </div>
          </div>
        </div>
        <button type="button" class="cart-item__remove" data-action="remove" data-id="${
          item.key
        }" aria-label="Remove">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18"><path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
        </button>
      </div>
    `,
      )
      .join("");

    container.innerHTML = `<div class="cart-drawer__item-list">${itemsHtml}</div>`;
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }
}
